import { StatusObject } from '@yes.technology/react-toolkit'
import apiAsync from 'utils/api-async'

export default async function fetchStatuses(
  objectclassUuid: unknown,
  showLoading: boolean
): Promise<StatusObject[] | null> {
  const response = await apiAsync.requestSync({
    endpoint: 'objects_filter',
    method: 'POST',
    obj: {
      query: {
        'situation.des': {
          $gte: '40'
        },
        'objectclass.uuid': {
          $in: [objectclassUuid]
        }
      },
      objectclass: 'UUID_OBJECTCLASS_STATUS',
      orderby: [],
      pagination: {
        offset: 0,
        limit: 100
      }
    },
    showLoading
  })

  return response.data.objects as StatusObject[] | null
}
